import { handleActions } from "redux-actions";
import {
    getObjectStructuresEntities,
    getObjectStructuresSuccess,
    getObjectStructuresError,
    setObjectStructuresDialog,
    mergeObjectStructuresDialog,
    storeObjectStructures,
    setValidatorsObjectStructureDialog,
    mergeValidatorsObjectStructureDialog,
    clearObjectStructures
} from "modules/ObjectStructures/services/Entities/actions";

const initialState = {
    isLoading: false,
    codes: [],
    entities: [],
    count: 0,
    initialValues: null,
    objectStructuresDialog: { isOpen: false },
    validatorsObjectStructuresDialog: { 
        isOpen: false,
        data: {},
        indexProperty: null
    }
};

export const entitiesReducer = handleActions(
    {
        [clearObjectStructures]: () => ({ ...initialState }),
        [getObjectStructuresEntities]: (state) => ({
            ...state,
            codes: [],
            entities: [],
            count: 0,
            isLoading: true
        }),
        [getObjectStructuresSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getObjectStructuresError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [setObjectStructuresDialog]: (state, { payload }) => ({
            ...state,
            objectStructuresDialog: {
                ...initialState.objectStructuresDialog,
                ...payload
            }
        }),
        [mergeObjectStructuresDialog]: (state, { payload }) => ({
            ...state,
            objectStructuresDialog: {
                ...state.objectStructuresDialog,
                ...payload
            }
        }),

        [storeObjectStructures]: (state, { payload }) => ({
            ...state,
            initialValues: payload
        }),

        [setValidatorsObjectStructureDialog]: (state, { payload }) => ({
            ...state,
            validatorsObjectStructuresDialog: {
                ...initialState.validatorsObjectStructuresDialog,
                ...payload
            }
        }),
        [mergeValidatorsObjectStructureDialog]: (state, { payload }) => ({
            ...state,
            validatorsObjectStructuresDialog: {
                ...state.validatorsObjectStructuresDialog,
                ...payload
            }
        })
    },
    initialState
);
